import { useSyncExternalStore } from 'react';
import { subscribeSyncQueue, getSyncQueueSnapshot } from '../utils/syncQueueStore';

/**
 * Aggregate pending + failed optimistic-sync counts for every period belonging
 * to a given scope (a plan or a template). Used by the Save-button pages to
 * disable Save/Next while work is outstanding and to render the status line.
 * @param {string} scopeKey e.g. `plan-42` or `template-7`
 */
export function usePendingSyncTotal(scopeKey) {
  const snapshot = useSyncExternalStore(subscribeSyncQueue, getSyncQueueSnapshot);
  let pending = 0;
  let error = 0;
  if (scopeKey) {
    Object.entries(snapshot).forEach(([key, v]) => {
      if (key.startsWith(`${scopeKey}:`)) {
        pending += v.pending;
        error += v.error;
      }
    });
  }
  return { pending, error, total: pending + error };
}
